import { SERVICE_LINE_NAMES } from '../config';
import {
  editPatient,
  getAllRelatives,
  getDentalRelatives,
  getPatients,
  getRelatives,
  saveNewPatient,
  selectPatient,
  getPhysioRelatives,
} from '../services';
import { store } from '../store';

const {
  user: { authToken, userId },
} = store.getState();

const COMMON = {
  addFunction: (patientDetails) => saveNewPatient(patientDetails),
  editFunction: (patientDetails) => editPatient(patientDetails),
  getPatient: (t) => getAllRelatives(authToken, t),
  selectPatient: null,
  showEditPatient: false,
  showAddPatient: false,
  responseKey: 'patients',
  addSelfManually: true,
};

export const PATIENT_MODAL_CONFIG = {
  [SERVICE_LINE_NAMES.TELE]: { ...COMMON, responseKey: 'relatives' },

  [SERVICE_LINE_NAMES.OFFLINE]: {
    ...COMMON,
    getPatient: () => getAllRelatives(userId),
    responseKey: 'relatives',
  },

  [SERVICE_LINE_NAMES.PREBOOK]: {
    ...COMMON,
    getPatient: () => getAllRelatives(userId),
    responseKey: 'relatives',
  },

  [SERVICE_LINE_NAMES.LABS]: {
    ...COMMON,
    getPatient: (cartId, isConciergeBooking) =>
      getPatients(null, null, cartId, null, isConciergeBooking),
    selectPatient: (cartId, patientId) => selectPatient(cartId, patientId),
    showEditPatient: true,
    showAddPatient: true,
    addSelfManually: false,
  },

  [SERVICE_LINE_NAMES.PHARMACY]: {
    ...COMMON,
    getPatient: () => getPatients(),
    showEditPatient: true,
    showAddPatient: true,
    addSelfManually: false,
  },

  [SERVICE_LINE_NAMES.SEARCHBOOK]: {
    ...COMMON,
    getPatient: () => getPatients(),
    showEditPatient: true,
    showAddPatient: true,
    addSelfManually: false,
  },

  [SERVICE_LINE_NAMES.DENTAL]: {
    ...COMMON,
    getPatient: () => getDentalRelatives(),
    responseKey: 'relatives',
    addSelfManually: true,
  },
  [SERVICE_LINE_NAMES.VISION]: {
    ...COMMON,
    responseKey: 'relatives',
  },

  [SERVICE_LINE_NAMES.PHYSIO]: {
    ...COMMON,
    getPatient: () => getPhysioRelatives(),
    responseKey: 'userPolicyDetails',
    selectPatient: (cartId, patientId) => selectPatient(cartId, patientId),
    showEditPatient: false,
    showAddPatient: false,
    addSelfManually: false,
  },
};
